import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import * as actions from './actions'
import initialState from './initialState'
import HeaderStateType, { HeaderProps } from './types'

const fetchHeaderStart = (state: HeaderStateType): HeaderStateType => ({
  ...state,
  headerStatus: LoadingStates.Loading,
})

const fetchHeaderSuccess = (state: HeaderStateType, payload: HeaderProps): HeaderStateType => ({
  ...state,
  ...payload,
  headerStatus: LoadingStates.LoadedSuccess,
})

const fetchHeaderFail = (state: HeaderStateType): HeaderStateType => ({
  ...state,
  headerStatus: LoadingStates.LoadedFail,
})

const reducer = createReducer((on) => {
  on(actions.fetchHeaderStart, fetchHeaderStart)
  on(actions.fetchHeaderSuccess, fetchHeaderSuccess)
  on(actions.fetchHeaderFail, fetchHeaderFail)
}, initialState)

export default reducer
